export enum itemCheck {
    good = 1,
    regular,
    change,
    not_Applied
}